var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.credentials.access_token)?_c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('Navbar'),_c('v-main',{staticClass:"print-no-spacing"},[_c('router-view',{staticClass:"mx-6 print-no-spacing"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }